import * as React from 'react';
import styled from 'styled-components';
import { Accordion, AccordionItem, AccordionItemButton, AccordionItemHeading, AccordionItemPanel, } from 'react-accessible-accordion';
import { v4 as uuidv4 } from 'uuid';
import { Box, get, Icon, TextBody } from '@ally/metronome-ui';
import { deprecated } from '@ally/metronome-icons';
import { MultiConsentProvider, useMultiConsent } from '.';
const StyledAccordion = styled(Accordion) `
  ${({ theme: { colors, space } }) => `
    border-radius: 2px;
    background-color: ${colors['light-gray']};
    border: 1px solid ${colors['slate-3']};
    border-bottom: ${space.none};
    box-shadow: ${space.none} 0.35rem ${space.none} rgba(0, 0, 0, 0.1);
  `}}
`;
const StyledAccordionItemButton = styled(AccordionItemButton) `
  display: flex;
  align-items: center;
  cursor: pointer;
  width: 100%;
  text-align: left;
  border: none;
  font-size: ${get.fontSizes('sm')};
  font-weight: bold;
  font-family: ${get.fonts('regular')};
  color: ${get.colors('slate-5')}; // blueseudeshoes
  height: 32px;

  .svg-wrapper {
    margin-right: 8px;
  }

  ${({ theme: { colors, media, space } }) => `
    background-color: ${colors['light-gray']};
    padding: ${space.xxs} ${space.sm};
    border-bottom: 1px solid ${colors['slate-3']};
    ${media.down('md')} {
      height: 45px;
    }
  `}}
`;
const AccordionHeader = styled(TextBody) `
  line-height: 1.25;
  vertical-align: middle;
  display: table-cell;
`;
const StyledAccordionItemPanel = styled(AccordionItemPanel) `
  ${({ theme: { colors, space } }) => `
    padding: ${space.sm};
    /* box-shadow at the top of the accordion content when in a container */
    box-shadow: inset 0 4px 0 0 rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid ${colors['slate-3']};
    background-color: ${colors.white};
  `}}
`;
// There is a bug in Edge where removing the 'hidden' attribute won't update
// the dom and show the previously hidden contents. Adding this style
// explicitly somehow resolves this.
const StyledAccordionItem = styled(AccordionItem) `
  && {
    [id^='accordion__panel-'][hidden] {
      display: none;
    }
  }
`;
const StyledSvgWrapper = styled(Box) `
  height: 100%;
  display: flex;
  align-items: center;
`;
export const MultiConsentContent = ({ consents, status, }) => {
    const { activeConsentIndex, focusIndex, setAsyncStatus, successByIndex, } = useMultiConsent();
    React.useEffect(() => {
        setAsyncStatus(status);
    }, [status]);
    const indexedConsents = consents.map((consent, index) => {
        // All but the first consent should auto focus on mount
        return Object.assign(Object.assign({}, consent), { component: React.cloneElement(consent.component, {
                index,
            }), accordionKey: uuidv4() });
    });
    return (React.createElement(StyledAccordion, { preExpanded: [0] }, indexedConsents.map(({ title, component, accordionKey }, idx) => (React.createElement(StyledAccordionItem, { key: accordionKey, uuid: idx, dangerouslySetExpanded: idx === activeConsentIndex },
        React.createElement(AccordionItemHeading, null,
            React.createElement(StyledAccordionItemButton, null,
                successByIndex[idx] && (React.createElement(StyledSvgWrapper, { className: "svg-wrapper" },
                    React.createElement(Icon, { "aria-live": "polite", "aria-roledescription": "success icon", "aria-label": "form successfully completed", icon: deprecated.muiSuccessOutline, unsupportedCustomWidth: 15, unsupportedCustomHeight: 15, fill: "success" }))),
                React.createElement(AccordionHeader, Object.assign({ "aria-roledescription": "heading", "aria-label": `Step ${idx + 1}: ${title}`, tag: "span", size: "sm" }, (focusIndex && idx === focusIndex
                    ? { focusOnMount: true }
                    : {})), title))),
        React.createElement(StyledAccordionItemPanel, null, component))))));
};
export const MultiConsent = ({ consents, onComplete, status, }) => {
    return (React.createElement(MultiConsentProvider, { consents: consents, onComplete: onComplete },
        React.createElement(MultiConsentContent, { consents: consents, status: status })));
};
export default MultiConsent;
//# sourceMappingURL=MultiConsent.js.map